/* eslint-disable @typescript-eslint/no-explicit-any */
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { SideModal } from '@design-system/components/modal/sideModal';
import { Typography } from '@design-system/components/typography/typography';
import { Col, Row } from '@design-system/components/grid/grid';
import { SearchInput } from '@design-system/components/searchinput';
import { Button } from '@design-system/components/button/button';
import { Switch } from '@client/new/components/basic';
import { GridList } from './components/GridList';
import { discountRowSchema } from '../view-model/discounts.mappers';
import {
  DiscountsVM,
  filterTypeOptions,
} from '../view-model/discounts.viewModel';
import { NewDiscountForm } from './NewDiscount.view';

import * as styles from './Discounts.view.css';
import { MenuSelect } from './components/MenuSelect';
import { DeactivateModal } from './DeactivatingModal';
import { CopyLinkModal } from '@design-system/components/modals/CopyLinkModal';

export const DiscountsView = (p: DiscountsVM) => (
  <Col className={styles.wrapper} gap="xl">
    {p.discountsCnt === 0 ? <EmptyDiscounts {...p} /> : <Discounts {...p} />}

    <SideModal
      isOpen={p.mode === 'filling'}
      onClose={() => p.dispatch('ToggleModal')}
      noSpacing
      testId="discounts"
    >
      <div className={styles.formWrapper}>
        <NewDiscountForm {...p.newDiscount} otps={p.otps} />
      </div>
    </SideModal>
  </Col>
);

const EmptyDiscounts = (p: DiscountsVM) => (
  <Col className={styles.emptyDiscountsCol}>
    <Col>
      <Typography variant="headline" size="medium">
        Create a discount code
      </Typography>
      <Typography variant="bodyLarge" color="B-60">
        Increase sales by offering discounts on products. <br />
        Your discounts will be displayed here
      </Typography>
    </Col>
    <Button
      leftIcon={faPlus}
      color="neutral"
      onClick={() => p.dispatch('ToggleModal')}
      testId="NewDiscountButton"
      style={{ maxHeight: 44, marginTop: 24 }}
    >
      New Discount
    </Button>
  </Col>
);

const Discounts = (p: DiscountsVM) => {
  return (
    <>
      <Row className={styles.headerRow}>
        <div className={styles.filtersRow}>
          <SearchInput
            placeholder="Search by name, code or status"
            value={p.search}
            onChange={(e) => p.dispatch('SetSearch', e.target.value)}
            onClear={() => p.dispatch('SetSearch', '')}
          />
          <MenuSelect
            options={filterTypeOptions}
            onChange={(e) => p.dispatch('SetFilterType', e.target.value as any)}
            value={p.filters.type}
            name="filterType"
          />
          <div className={styles.switchRow}>
            <label htmlFor={'inactive'} style={{ fontWeight: '600' }}>
              Show Inactive
            </label>
            <Switch
              id={'inactive'}
              className="ml-2"
              checked={p.filters.status === 'All'}
              onChange={() =>
                p.dispatch(
                  'SetFilterStatus',
                  p.filters.status === 'All' ? 'Active' : 'All',
                )
              }
            />
          </div>
          {/* <MenuSelect
          options={filterStatusOptions}
          onChange={(e) => p.dispatch('SetFilterStatus', e.target.value as any)}
          value={p.filters.status}
          name="filterStatus"
        /> */}
        </div>
        <NewDiscountButton {...p} />
      </Row>

      <GridList schema={discountRowSchema} rows={p.rows} />
      <DeactivateModal
        deactivationMode={p.deactivationMode}
        onClose={() => p.dispatch('CloseDeactivating')}
        onConfirm={() => p.dispatch('FinishDeactivation')}
      />
      <CopyLinkModal
        isOpen={p.confirmModalMode.type !== 'not-started'}
        onClose={() => p.dispatch('CloseConfirmModal')}
        title="Share your discount"
        linkTitle="Discount Checkout Page"
        linkDesc="Use this link to bring users straight to a checkout page with your discount code already applied"
        desc={`It's ready for use in your email campaigns, social media posts, and more! You can always find this link again on the Promotions tab.`}
        url={
          p.confirmModalMode.type === 'in-progress'
            ? p.confirmModalMode.value
            : ''
        }
      />
    </>
  );
};

const NewDiscountButton = (p: DiscountsVM) => (
  <Button
    leftIcon={faPlus}
    color="neutral"
    onClick={() => p.dispatch('ToggleModal')}
    testId="NewDiscountButton"
    style={{ maxHeight: 44 }}
  >
    New
  </Button>
);
